import styled from "styled-components";

export const ImgIcon = styled.img`
width: 35px;
cursor: pointer;
`;